<script setup lang="ts">
const props = defineProps({
  subtype: {
    type: String,
    required: true,
  },
  style: {
    type: Object,
    required: true,
  },
})
</script>

<template>
  <svg
    v-if="subtype === 'square'"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1"
      y="1"
      :width="30 - style.stroke[0].width * 2"
      :height="30 - style.stroke[0].width * 2"
      :fill="style.fill"
      :stroke="style.stroke[0].color"
      :stroke-width="style.stroke[0].width"
    />
  </svg>

  <svg
    v-if="subtype === 'small_dot'"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8" r="8" :fill="style.fill" />
  </svg>

  <svg
    v-if="subtype === 'big_dot'"
    width="26"
    height="26"
    viewBox="0 0 26 26"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="13" cy="13" r="13" :fill="style.fill" />
  </svg>

  <svg
    v-if="subtype === 'triangle'"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15 3 L27 26 L3 26 Z" :fill="style.fill" />
  </svg>

  <svg
    v-if="subtype === 'car'"
    height="30"
    width="30"
    viewBox="0 -960 960 960"
    :fill="style.fill"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M240-160q-50 0-85-35t-35-85H80q-17 0-28.5-11.5T40-320v-400q0-33 23.5-56.5T120-800h480q33 0 56.5 23.5T680-720v80h80q19 0 36 8.5t28 23.5l88 117q4 5 6 11t2 13v147q0 17-11.5 28.5T880-280h-40q0 50-35 85t-85 35q-50 0-85-35t-35-85H360q0 50-35 85t-85 35Zm0-80q17 0 28.5-11.5T280-280q0-17-11.5-28.5T240-320q-17 0-28.5 11.5T200-280q0 17 11.5 28.5T240-240Zm480 0q17 0 28.5-11.5T760-280q0-17-11.5-28.5T720-320q-17 0-28.5 11.5T680-280q0 17 11.5 28.5T720-240Zm-40-200h170l-90-120h-80v120Z"
    />
  </svg>
</template>
